import { type Variants, motion } from "motion/react";

const pathVariants: Variants = {
  hidden: { pathLength: 0, opacity: 0 },
  visible: (i) => ({
    pathLength: 1,
    opacity: 1,
    transition: {
      pathLength: {
        type: "tween",
        duration: 0.8,
        delay: i * 0.1,
      },
      opacity: {
        duration: 0.01,
        delay: i * 0.1,
      },
    },
  }),
};

export function AnimatedLogo({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 845.71 845.71"
      className={className}
    >
      <title>MoonPixel Logo</title>
      <motion.path
        d="M394.67 28.19h112.76V0H338.29v28.19h56.38z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={0}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M310.09 56.38h28.2V28.19h-84.58v28.19h56.38z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={1}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M535.62 56.38H592V28.19H507.43v28.19h28.19z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={2}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M253.71 84.57V56.38h-56.38v28.19h56.38z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={3}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M169.14 84.57h28.19v28.19h-28.19z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={4}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M140.95 112.76h28.19v28.19h-28.19z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={5}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M112.76 140.95h28.19v28.19h-28.19z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={6}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M84.57 169.14h28.19v28.19H84.57z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={7}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M84.57 225.52v-28.19H56.38v56.38h28.19v-28.19z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={8}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M56.38 310.09v-56.38H28.19v84.58h28.19v-28.2z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={9}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M817.52 338.29v-84.58h-28.19v-56.38h-28.19v-28.19h-28.19v-28.19h-28.19V84.57h-28.19V56.38H592v28.19h28.19v28.19h28.19v56.38h28.19v169.15h-28.19v28.19h28.19v28.19h28.19v28.19h28.19v-56.38h28.19V507.43h-28.19v-28.19h-28.19v-28.19h-28.19v56.38h-28.19V422.86h-28.19v-28.19H592V479.24H507.43v28.19h56.38v28.19h-28.19v28.19h-28.19V592h-28.19v28.19h-56.38v28.19H338.29v28.19H169.14v-28.19h-56.38v-28.19H84.57V592H56.38v56.38h28.19v28.19h28.19v28.19h28.19v28.19h28.19v28.19h28.19v28.19h56.38v28.19h84.58v28.19H507.43v-28.19H592v-28.19h56.38v-28.19h28.19v-28.19h28.19v-28.19h28.19v-28.19h28.19v-28.19h28.19V592h28.19V507.43h28.19V338.29h-28.19z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={10}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M394.67 394.67h28.19v-28.19H338.29v28.19h56.38z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={11}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M563.81 366.48h-56.38v28.19H592v-28.19h-28.19z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={12}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M140.95 422.86h28.19v28.19h-28.19z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={13}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M197.33 422.86h28.19v28.19h-28.19z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={14}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M253.71 451.05v56.38h28.19V366.48h-28.19v28.19h-28.19v28.19h28.19v28.19z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={15}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M422.86 451.05v28.19h28.19V394.67h-28.19v56.38z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={16}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M507.43 422.86v-28.19h-28.19V479.24h28.19v-56.38z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={17}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M28.19 451.05V338.29H0V507.43h28.19v-56.38z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={18}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M338.29 451.05v-56.38h-28.2V479.24h28.2v-28.19z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={19}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M112.76 479.24v-56.38h28.19v-28.19h-28.19v-28.19H84.57V507.43h28.19v-28.19z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={20}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M169.14 507.43h28.19v-56.38h-28.19v56.38z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={21}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M366.48 479.24h-28.19v28.19H422.86v-28.19h-56.38z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={22}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <motion.path
        d="M56.38 535.62v-28.19H28.19V592h28.19v-56.38z"
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        custom={23}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
}
